<template>
    <div class="test-results">
        <h2>Uitslag profielkeuzetest</h2>
        <p class="description">Hieronder zie je jouw scores op de vier profielen van HAVO en VWO:</p>

        <div class="bar-chart mx-auto my-3">
            <design2021-apprentice-basic-bar-chart-component
                class="mb-5"
                :options="chartOptions"
                :series="series">
            </design2021-apprentice-basic-bar-chart-component>
        </div>

        <p>
            Volgens de test heb je een voorkeur voor het profiel <strong>{{ resultLabel }}</strong
        >. Herken je dit? Als je dit niet herkent of twijfelt tussen bepaalde profielen, lees dan de tips hieronder.
        </p>

        <p>
            <ul class="list-unstyled">
                <li>
                    <strong>C&M:</strong> Cultuur en Maatschappij
                </li>
                <li>
                    <strong>E&M:</strong> Economie en Maatschappij
                </li>
                <li>
                    <strong>N&G:</strong> Natuur en Gezondheid
                </li>
                <li>
                    <strong>N&T:</strong> Natuur en Techniek
                </li>
            </ul>
        </p>

        <h3 class="sub-title mt-4">Tips profielkeuze</h3>
        <ul>
            <li>Bespreek de uitslag met je ouder(s) en met vrienden.</li>
            <li>Bespreek de uitslag met je mentor of de schooldecaan.</li>
            <li>Bij twijfel kan je ook kiezen voor het profiel waar je gemiddeld de beste cijfers voor haalt.</li>
            <li>
                Zijn er bepaalde studies of beroepen die je heel leuk lijken? Kijk dan of je deze niet uitsluit met een
                bepaalde profielkeuze.
            </li>
        </ul>
    </div>
</template>

<script>
    import { getAttributeForKey, getAttributesForKeys, sortResults } from '../../../../helpers/testCenter';
    import Design2021ApprenticeBasicBarChartComponent from '../../../common/charts/design-2021-apprentice-basic-bar-chart-component.vue';

    const testKey = 'job-personality-profile-choice-test-2024-06-12';

    export default {
        components: { Design2021ApprenticeBasicBarChartComponent },
        props: {
            resultData: {
                type: Object
            }
        },
        data() {
            return {
                series: [
                    {
                        data: sortResults(testKey, this.resultData)
                    }
                ],
                chartOptions: {
                    chart: {
                        toolbar: {
                            tools: {
                                download: false
                            }
                        }
                    },
                    plotOptions: {
                        bar: {
                            barHeight: '100%',
                            distributed: true,
                            columnWidth: '50%',
                            dataLabels: {
                                show: false
                            }
                        }
                    },
                    colors: ['#40b4ff'],
                    xaxis: {
                        categories: getAttributesForKeys(testKey, 'abbreviation'),
                        labels: {
                            style: {
                                fontSize: '14px',
                                fontFamily: 'DM Sans'
                            }
                        },
                        axisBorder: {
                            show: false
                        },
                        axisTicks: {
                            show: false
                        }
                    },
                    yaxis: {
                        show: false
                    },
                    grid: {
                        show: false
                    },
                    dataLabels: {
                        enabled: false
                    },
                    tooltip: {
                        enabled: false
                    },
                    legend: {
                        show: false
                    },
                    states: {
                        active: {
                            filter: {
                                type: 'none',
                            },
                        },
                        hover: {
                            filter: {
                                type: 'none',
                            },
                        },
                    },
                },
                resultLabel: getAttributeForKey(testKey, this.determineResultKey(this.resultData), 'label')
            };
        },
        methods: {
            determineResultKey(resultData) {
                return (
                    Object.keys(resultData)
                        // Sort the keys by score and importance
                        .sort((a, b) => {
                            const scoreDifference = resultData[b] - resultData[a];
                            if (scoreDifference !== 0) return scoreDifference;
                            return (
                                getAttributeForKey(testKey, a, 'order') - getAttributeForKey(testKey, b, 'order')
                            );
                        })[0]
                );
            }
        }
    };
</script>

<style scoped lang="scss">
    .description {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    }

    .bar-chart {
        height: 350px;
        max-width: 650px;
    }
</style>
